import { render, staticRenderFns } from "./ProcessandoPedido.vue?vue&type=template&id=ef51a832&"
import script from "./ProcessandoPedido.vue?vue&type=script&lang=js&"
export * from "./ProcessandoPedido.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports